import {useMapContext} from '@/components/MindMap/index.mjs'
import usePermission from '@/hooks/usePermission.mjs'
import openWindow from '@/script/openWindow.mjs'

export default () => {
    const map = useMapContext()
    const {mapTypeCode, prjId, sVer} = map.data
    const hasPermission = usePermission(['BD_UPT'], [`${prjId}${sVer ?? ''}`])

    if ('SA_MAP' !== mapTypeCode || ! hasPermission) {
        return null
    }

    const onClick = () => openWindow('/MigrateDeList', {prjId, sVer})

    return {
        label: '迁移数据实体',
        onClick,
    }
}
